<template>
  <div>
    <div class="contents">
      <b-form @submit="onSubmit">
        <div class="filter-box-2">
          <div>
            <select class="form-select-lg" v-model="searchData.searchtype">
              <option value="0">{{ $t("filter.common.total") }}</option>
              <option value="1">
                {{ $t("filter.golfcourse.golfcourse_name") }}
              </option>
              <option value="2">
                {{ $t("filter.golfcourse.golfcourse_code") }}
              </option>
            </select>
          </div>
          <div class="search-input">
            <input
              type="text"
              class="form-control-lg"
              v-model="searchData.searchname"
            />
            <input
              class="btn btn-primary btn-lg search"
              type="submit"
              value=""
            />
          </div>
        </div>
      </b-form>

      <table class="table board">
        <thead>
          <tr>
            <th class="col-auto d-none d-lg-table-cell w-1">
              {{ $t("title.common.number") }}
            </th>
            <th class="col-auto">
              {{ $t("title.common.course") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell w-1">
              {{ $t("title.common.hole") }}
            </th>
<!--             <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.golfcourse.difficulty") }}<br>
              <small class="fw-500">
                ({{ $t("title.golfcourse.golfcourse_difficulty") }}/{{
                  $t("title.golfcourse.green_difficulty") }})
              </small>
            </th> -->
            <th class="col-auto d-none d-lg-table-cell text-nowrap">
              <span class="d-block">{{ $t("title.golfcourse.golfcourse_difficulty") }}</span>
              <span class="d-block">{{ $t("title.golfcourse.green_difficulty") }}</span>
            </th>            
            <th class="col-auto d-none d-lg-table-cell w-1">
              {{ $t("title.common.status") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell w-1">
              {{ $t("title.golfcourse.view_status") }}
            </th>
            <th class="th-arrow"></th>
          </tr>
        </thead>
        <tbody v-if="data_yn">
          <template v-for="(item, index) in items">
            <tr :key="index">
              <td class="col-auto d-none d-lg-table-cell">{{ item.no }}</td>
              <td class="col-auto text-start">
                <router-link
                  :to="{
                    name: 'CourseView',
                    params: { courseno: item.courseno },
                  }"
                  class="d-inline-block"
                >
                  <span class="fs-13 text-capitalize text-teal">{{ item.coursecode }}</span><br>
                  <span class="more">{{ item.coursename }}</span>
                </router-link>
              </td>              
              <td class="col-auto d-none d-lg-table-cell">
                {{ item.hole }}H
              </td>
              <td class="col-auto d-none d-lg-table-cell">
                <p>
                  <i
                    class="material-icons"
                    :class="item.field >= index ? 'text-yellow' : 'text-lightgray'"
                    v-for="index in 5"
                    :key="index"
                    >star</i
                  >
                </p>
                <p>
                  <i
                    class="material-icons"
                    :class="item.green >= index ? 'text-green' : 'text-lightgray'"
                    v-for="index in 5"
                    :key="index"
                    >flag</i
                  >
                </p>
              </td>
              <td class="col-auto d-none d-lg-table-cell">
                <label
                  :class="{
                    'status-pend min-w-64px': item.status === '1',
                    'status-done min-w-64px': item.status !== '1'
                  }"                
                >
                  {{
                    item.status === "1"
                      ? $t("filter.golfcourse.queued")
                      : $t("filter.common.use")
                  }}
                </label>
              </td>
              <td class="col-auto d-none d-lg-table-cell">
                <label
                  :class="{
                    'status-done px-2 border-0': item.viewflag === '1',
                    'status-drop px-2 border-0': item.viewflag !== '1'
                  }"
                >                
                  {{ item.viewflag === "1" ? "O" : "X" }}
                </label>
              </td>
              <td class="td-arrow" @click="toggle_tr(index)">
                <img
                  src="/img/arrow_none_collapsed.png"
                  :class="{ 'btn-toggle-arrow': view_hide === index }"
                />
              </td>
            </tr>
            <tr
              class="col-auto d-lg-none d-md-tabel-cell"
              :class="{ show: view_hide === index }"
              :key="index + 'r'"
              v-if="view_hide === index"
            >
              <td class="text-start" colspan="6">
                <div class="toggle-content">
                  <div class="row">
                    <div class="col-6">{{ $t("title.common.number") }}</div>
                    <div class="col-6">{{ item.no }}</div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      {{ $t("title.common.hole") }}
                    </div>
                    <div class="col-6">{{ item.hole }}H</div>
                  </div>
<!--                   <div class="row">
                    <div class="col-6">
                      {{ $t("title.golfcourse.difficulty") }}<br /><small
                        >({{ $t("title.golfcourse.golfcourse_difficulty") }}/{{
                          $t("title.golfcourse.green_difficulty")
                        }})</small
                      >
                    </div>
                    <div class="col-6">
                      <p>
                        <i
                          class="material-icons-outlined"
                          :class="
                            item.field >= index ? 'text-yellow' : 'text-lightgray'
                          "
                          v-for="index in 5"
                          :key="index"
                          >star</i
                        >
                      </p>
                      <p>
                        <i
                          class="material-icons"
                          :class="
                            item.green >= index ? 'text-green' : 'text-lightgray'
                          "
                          v-for="index in 5"
                          :key="index"
                          >flag</i
                        >
                      </p>
                    </div>
                  </div> -->
                  <div class="row">
                    <div class="col-6">
                      {{ $t("title.golfcourse.golfcourse_difficulty") }}
                    </div>
                    <div class="col-6">
                      <i
                        class="material-icons-outlined"
                        :class="
                          item.field >= index ? 'text-yellow' : 'text-lightgray'
                        "
                        v-for="index in 5"
                        :key="index"
                        >star</i
                      >                      
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      {{ $t("title.golfcourse.green_difficulty") }}
                    </div>
                    <div class="col-6">
                      <i
                        class="material-icons"
                        :class="
                          item.green >= index ? 'text-green' : 'text-lightgray'
                        "
                        v-for="index in 5"
                        :key="index"
                        >flag</i
                      >                      
                    </div>
                  </div>                  
                  <div class="row">
                    <div class="col-6">{{ $t("title.common.status") }}</div>
                    <div class="col-6">
                      <label
                        :class="{
                          'status-pend min-w-64px': item.status === '1',
                          'status-done min-w-64px': item.status !== '1'
                        }"                
                      >
                        {{
                          item.status === "1"
                            ? $t("filter.golfcourse.queued")
                            : $t("filter.common.use")
                        }}
                      </label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      {{ $t("title.golfcourse.view_status") }}
                    </div>
                    <div class="col-6">
                      <label
                        :class="{
                          'status-done px-2 border-0': item.viewflag === '1',
                          'status-drop px-2 border-0': item.viewflag !== '1'
                        }"
                      >                
                        {{ item.viewflag === "1" ? "O" : "X" }}
                      </label>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="6" class="text-center">{{ $t("text.common.no_data") }}</td>
          </tr>
        </tbody>
      </table>
      <b-pagination-nav
        :link-gen="linkGen"
        :number-of-pages="page_total"
        v-model="searchData.pageno"
        use-router
        :aria-label="$t('text.common.pagination')"
        v-if="page_total > 1"
        first-class="prev"
        prev-class="prev"
        next-class="next"
        last-class="next"
        hide-ellipsis
        limit="10"
      >
        <template #first-text
          ><i class="material-icons">keyboard_double_arrow_left</i></template
        >
        <template #prev-text
          ><i class="material-icons">navigate_before</i></template
        >
        <template #next-text
          ><i class="material-icons">navigate_next</i></template
        >
        <template #last-text
          ><i class="material-icons">keyboard_double_arrow_right</i></template
        >
        <template #page="{ page, active }">
          <div v-if="active">{{ page }}</div>
          <div v-else>{{ page }}</div>
        </template>
      </b-pagination-nav>
      <div class="btn-bottom-wrapper">
	      <b-button
            size="xl"
            variant="primary"
            :aria-label="$t('button.common.write')"
	         @click="$router.push({ name: 'CourseWrite' })"
            >{{ $t("button.common.write") }}</b-button
          >
      </div>
    </div>
  </div>
</template>

<script>
import ax from "@/api/course";

export default {
  name: "CourseList",
  data() {
    return {
      searchData: {
        searchtype:
          this.$route.query.searchtype ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchtype) ||
          1,
        searchname:
          this.$route.query.searchname ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchname) ||
          "",
        pageno:
          this.$route.query.pageno ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].pageno) ||
          1,
      },
      page_total: 1,
      total_cnt: 0,
      data_yn: true,
      rows: 10,
      items: [],
      view_hide: null,
    };
  },
  watch: {
    "searchData.searchtype": function () {
      this.searchData.pageno = 1;
      this.get_admincourselist();
    },
    "searchData.searchname": function () {
      this.searchData.pageno = 1;
      this.get_admincourselist();
    },
    "searchData.pageno": function () {
      this.get_admincourselist();
    },
  },

  methods: {
    onSubmit(event) {
      event.preventDefault();
      this.searchData.pageno = 1;
      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      this.get_admincourselist();
    },
    get_admincourselist() {
      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      ax.get_admincourselist(this.searchData, (flag, data) => {
        if (flag) {
          if (data.courselistcnt <= 0) {
            this.data_yn = false;
          } else {
            this.data_yn = true;
          }
          this.total_cnt = data.courselistcnt;
          this.page_total = Math.ceil(data.courselistcnt / this.rows);
          this.items = data.courselist;
        } else {
          this.data_yn = false;
          this.page_total = 0;
          // alert(data);
        }
      });
    },
    linkGen(pageNum) {
      return `?page=${pageNum}`;
    },
    toggle_tr(index) {
      if (this.view_hide === index) this.view_hide = null;
      else this.view_hide = index;
    },
  },
  mounted() {
    this.get_admincourselist();
  },
};
</script>